/* KOA — colour name on hover/focus for product-card swatches.
   Writes the hovered swatch's existing .sr-only name into the card's
   .koa-swatch-count line and restores the count on leave. Text-only:
   no positioning and no vendor style overrides — a position change here
   re-anchors Prestige's disabled-swatch diagonal (see koa.css note). */
(function () {
  function countFor(swatch) {
    var card = swatch.closest('product-card');
    return card ? card.querySelector('.koa-swatch-count') : null;
  }

  function show(swatch) {
    var countEl = countFor(swatch);
    if (!countEl) return;
    var name = swatch.querySelector('.sr-only');
    if (!name) return;
    if (!countEl.dataset.koaCount) countEl.dataset.koaCount = countEl.textContent;
    var label = name.textContent.trim();
    if (swatch.classList.contains('is-disabled')) label += ' — sold out';
    countEl.textContent = label;
  }

  function restore(swatch) {
    var countEl = countFor(swatch);
    if (countEl && countEl.dataset.koaCount) countEl.textContent = countEl.dataset.koaCount;
  }

  function swatchFromInput(input) {
    if (!input.id || typeof input.matches !== 'function') return null;
    if (!input.matches('input.sr-only[type="radio"]')) return null;
    return document.querySelector('label[for="' + CSS.escape(input.id) + '"].color-swatch');
  }

  document.addEventListener('mouseover', function (e) {
    var swatch = e.target.closest('.color-swatch');
    if (swatch) show(swatch);
  });

  document.addEventListener('mouseout', function (e) {
    var swatch = e.target.closest('.color-swatch');
    if (swatch) restore(swatch);
  });

  /* Keyboard parity: the radio input is the focusable element, not the label. */
  document.addEventListener('focusin', function (e) {
    var swatch = swatchFromInput(e.target);
    if (swatch) show(swatch);
  });

  document.addEventListener('focusout', function (e) {
    var swatch = swatchFromInput(e.target);
    if (swatch) restore(swatch);
  });
})();

/* KOA — sold-out restock block sync (buy-buttons.liquid).
   Prestige flips the ATC to "Sold out" client-side without re-rendering the
   area after the product form, so the server-rendered restock block goes
   stale on variant switches. Prestige dispatches a bubbling `variant:change`
   with the full variant object; we toggle the block and keep its colour tag
   and return_to pointing at the variant the shopper is actually looking at. */
(function () {
  function handleize(value) {
    return String(value).toLowerCase().trim().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }

  document.addEventListener('variant:change', function (e) {
    var block = document.getElementById('koa-restock');
    var variant = e.detail && e.detail.variant;
    if (!block || !variant) return;

    /* Ignore quick-buy/related-product forms — only the form sharing the
       block's section drives it. */
    var form = e.target;
    if (form.closest && block.closest('.shopify-section') !== form.closest('.shopify-section')) return;

    if (variant.available) {
      block.hidden = true;
      return;
    }
    block.hidden = false;

    var idx = parseInt(block.dataset.colourIndex, 10);
    var colour = idx >= 0 ? variant['option' + (idx + 1)] : '';

    var tagsInput = block.querySelector('input[name="contact[tags]"]');
    if (tagsInput) {
      var tags = 'restock-request,restock:' + block.dataset.productHandle;
      if (colour) tags += ',restock-colour:' + handleize(colour);
      tagsInput.value = tags;
    }

    var returnTo = block.querySelector('input[name="return_to"]');
    if (returnTo) returnTo.value = location.pathname + '?variant=' + variant.id + '&customer_posted=true#koa-restock';
  });
})();
